import React, {Component} from 'react';
import '../../style.css';
import {Button, Card, message, Modal, PageHeader, Space, Table} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Column } = Table;

class BuildProjectSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            project:[],
            fileStream:'',
            preview_visible:false,
            loading:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        this.setState(()=>({
            loading:true
        }))
        fetchPost(global.constants.getBuildProjectSummaryGetG,{companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            project:res.data,
                            loading:false
                        }))
                    }
                    else{
                        this.setState(()=>({
                            loading:false
                        }))
                       message.info(res.msg).then()
                    }
                }
            )
    }
    handleExportClick(){
        fetchPost(global.constants.exportBuildProjectSummaryG,{companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-12项目立项汇总表.doc',
            fileName: '项目立项汇总表.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-12项目立项汇总表.docx';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'项目汇总表.pdf'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: "/create/"+this.state.companyName+"/项目汇总表.pdf",
                            fileName: '项目汇总表.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    render() {
        let year = new Date().getFullYear();
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="项目立项汇总表"
                        extra={[
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Button
                                type="primary"
                                onClick={this.handlePreviewClick.bind(this)}
                            >预览</Button>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <div className = "content-header-area">
                        <span className="content-header">
                            {year-3}年-{year-1}年研究开发活动项目一览表
                        </span>
                    </div>
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.project} loading={this.state.loading}>
                            <Column align="center" title={<p className="list-column-style">项目编号</p>} dataIndex="code" key="code" />
                            <Column align="center" title={<p className="list-column-style">项目名称</p>} dataIndex="projectName" key="projectName" />
                            <Column
                                align="center"
                                dataIndex="time"
                                title={<p className="list-column-style">实施起止时间</p>}
                                key="time"
                            />
                            <Column align="center" title={<p className="list-column-style">证明材料</p>} dataIndex="evidence" key="evidence"/>
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'70%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                    />
                </Modal>
            </div>
        )
    }
}

export default BuildProjectSummary;